<template>
    <div >
        <apexchart ref="chart" 
        type="line"
        height="200px"
        :options="chartData.chartOptions"
        :series="chartData.series"
        :key="chartKey"
        >
        </apexchart>
        <!-- <v-btn @click="methodCall()">
click
        </v-btn> -->
    </div>
  </template>

  <script>
  // import VueApexCharts from "vue-apexcharts";
  import constants from "../constants";
  export default {
      name:'linechart',
      components:{
          // apexchart: VueApexCharts,
      },
      props:['apq'],
      data(){
          return{
            chartKey:0,
              showline:false,
              dbc_params_map:null,
              chartData : {
              id: this.apq.chartTitle,
              chartTitle: this.apq.chartTitle,
              chartOptions: {
              colors: this.getColors(this.apq.seriesvalues),//this is required property to send
              chart: {

                      animations: {
                                  enabled: false,
                                  },
                      height: "230px",
                      type: "line",
                      // zoom:{enabled: false},
                      // toolbar:{show: false},
                      // zoom: {
                      //         type: "x",
                      //         enabled: true,
                      //         autoScaleYaxis: false,
                      //     },
                      // toolbar: {},
                      // toolbar: {
                      //   show: false
                      // },
                      // zoom: {
                      //   enabled: false,
                      // },
                      zoom:{},
                      toolbar:{},
                      },
              annotations: {
                    yaxis: [
                      {
                  y: this.getAnnotationData(this.apq.highAlertValue) || -Infinity,
                        borderColor: "#ff0000",
                        borderWidth: 3,
                        label: {
                          borderColor: "#cc0066",
                          style: {
                            color: "#fff",
                            width: 2,
                            background: "#cc0066",
                          },
                        },
                      },
                      {
                  y: this.getAnnotationData(this.apq.highCautionValue) || -Infinity,
                        borderColor: "#FFA500",
                        borderWidth: 3,
                        label: {
                          borderColor: "#A52A2A",
                          style: {
                            color: "#fff",
                            width: 2,
                            background: "#cc0066",
                          },
                        },
                      },
                      {
                  y:this.getAnnotationData(this.apq.lowAlertValue) || -Infinity,
                        borderColor: "#ff0000",
                        borderWidth: 3,
                        label: {
                          borderColor: "#996633",
                          style: {
                            color: "#fff",
                            width: 2,
                            background: "#996633",
                          },
                        },
                      },
                                          {
                  y: this.getAnnotationData(this.apq.lowCautionValue) || -Infinity,
                        borderColor: "#FFA500",
                        borderWidth: 3,
                        label: {
                          borderColor: "#996633",
                          style: {
                            color: "#fff",
                            width: 2,
                            background: "#996633",
                          },
                        },
                      },
                    ],
                  },

                  legend: {
                    position: "bottom",
                    horizontalAlign: "center",
              showForSingleSeries: true,

              style: {},
                  },

                  xaxis: {
                    title: {
                      text: "Time",
                      align: "right",
                      style: {
                        color: "#484848",
                        fontSize: "14px",
                        fontWeight: "bold",
                      },
                    },
                    type: "datetime",
              categories: this.apq.timestampsLt,
              datetimeUTC: false,
                    labels: {
                datetimeUTC: false,
                    },
                    axisBorder: {
                      show: true,
                      color: "#78909C",
                      height: 1,
                      width: "100%",
                      offsetX: 0,
                      offsetY: 0,
                    },
                  },
                   grid: {
            borderColor: "#f1f1f1",
          },
            yaxis: 

            this.getYAxisProperties(this.apq.seriesvalues,this.apq.dbc_params_map),
            
                  stroke: {
                    width: [2, 2, 2],
            curve: "straight",
                  },
                  tooltip: {
                    shared: true,
                    intersect: false,
                    x: {
                      format: "dd MMM - HH : mm: ss",
                    },
                  },
                },
                series: this.apq.seriesvalues,
                markers: {
                    size: 10,
                },
              }
          }

      },
      
    beforeMount(){
      console.log("this.chartDatathis.chartData",this.chartData)
    //       if (this.apq !==null && this.apq!==undefined && Object.keys(this.apq).length >0){
    //           this.chartData.chartTitle = this.apq.chartTitle
    //           this.chartData.id = this.apq.chartTitle
    //           this.chartData.chartOptions.colors = this.getColors(this.apq.seriesvalues)
    //           this.chartData.series = this.apq.seriesvalues
    //           this.chartData.chartOptions.yaxis = this.getYAxisProperties(this.apq.seriesvalues,this.apq.dbc_params_map)
    //           this.chartData.chartOptions.xaxis.categories =this.apq.timestampsLt
    //           this.chartData.chartOptions.annotations.yaxis[0].y =this.getAnnotationData(this.apq.highAlertValue)
    //           this.chartData.chartOptions.annotations.yaxis[1].y = this.getAnnotationData(this.apq.highCautionValue)
    //           this.chartData.chartOptions.annotations.yaxis[2].y =this.getAnnotationData(this.apq.lowAlertValue)
    //           this.chartData.chartOptions.annotations.yaxis[3].y =this.getAnnotationData(this.apq.lowCautionValue)
    //           this.dbc_params_map = this.apq.dbc_params_map
    //           this.showline = true
              // if (this.apq.seriesvalues[0].data.length==0 || this.apq.seriesvalues[0].data===undefined){
              //   this.chartData.chartOptions.chart.toolbar={show: false}
              //   this.chartData.chartOptions.chart.zoom={enabled: false}
              // }else{
              //   this.chartData.chartOptions.chart.toolbar={}
              //   this.chartData.chartOptions.chart.zoom = {}
              // }

     },
     mounted(){
      console.log("this.chartData in livechart",this.chartData)

     },
     watch: {
    // chartData: {
    //   immediate: true,
    //   deep: true,
    //   handler() {
    //     console.log("saikrishna",this.apq.timestampsLt ,this.apq.seriesvalues)
    //   // Update the chart only if the necessary data is available
    //   if (this.apq && this.apq.timestampsLt && this.apq.seriesvalues) {
    //     this.$nextTick(() => {
    //       this.$refs.chart.updateOptions({
    //         xaxis: {
    //           categories: this.apq.timestampsLt
    //         }
    //       });
    //       this.$refs.chart.updateSeries(this.apq.seriesvalues);
    //     });
    //   }
    // }
    // },
    apq: {
    immediate: true,
    deep: true,
    handler() {
      console.log("this.prop cdkkn",this.apq)
      // Handle the prop change
      if (this.apq && this.apq.timestampsLt && this.apq.seriesvalues) {
        this.$nextTick(() => {
          this.$refs.chart.updateOptions({
            xaxis: {
              categories: this.apq.timestampsLt
            }
          });
          this.$refs.chart.updateSeries(this.apq.seriesvalues);
        });
      }
    }
  },},

    methods:{
    
      // methodCall(){
      //   // console.log(this.chartData)
      //   this.chartData.chartOptions.xaxis.categories = this.apq.timestampsLt
      //   this.chartData.series = this.apq.seriesvalues
      //   console.log(this.chartData.chartOptions.xaxis.categories)
      //   console.log(this.chartData.series)
      //   this.chartKey += 1;

      // },
          getColors(seriesvalues){
              let colors = [];
              let joiningColors = [];

              let count = seriesvalues.length;
              colors = constants.colors.slice(0, count);
              console.log("checking colors", colors);
              seriesvalues.forEach((param) => {
              if (param.name == "Alert") {
                  joiningColors.push(constants.exxonRed);
              } else if (param.name == "Caution") {
                  joiningColors.push(constants.darkOrange);
                  } else {
                  joiningColors.push(colors.shift());
                  }
              });
              console.log("joiningColors ", joiningColors);

                return joiningColors;
              },

          getYAxisProperties(seriesvalues,dbc_params_map){
          let yaxisArray = [];
          let multi_yaxis_display_array = [];
          console.log("checking values for data=>", seriesvalues);

          console.log("dbc_params_map here is ==>", dbc_params_map);
          let count = 0;
          seriesvalues.forEach((param) => {
            if (param.name == "Alert" || param.name == "Caution") {
              return;
            }
            console.log("checking param.name=>", param.name);
            let dbc_parameters_obj = {};
            if (dbc_params_map) {
              dbc_parameters_obj = dbc_params_map.get(param.name);
              console.log("dbc_parameters_obj=> 222",dbc_parameters_obj['yaxis_force_nice_scale'])
              console.log("dbc_parameters_obj=> 222", );
            }

                  let usual = {};
            let yaxis_title = "";
            if (
              dbc_parameters_obj != undefined &&
              "yaxis_title" in dbc_parameters_obj
            ) {
              yaxis_title = dbc_parameters_obj["yaxis_title"];
            }
            if (
              dbc_parameters_obj != undefined &&
              "series_type" in dbc_parameters_obj
            ) {
              param.type = dbc_parameters_obj["series_type"];
            }
                    usual.title = {
              text: yaxis_title,
                    };

            let decimals = 0;
                    console.log(decimals)
            if (
              dbc_parameters_obj != undefined &&
              "yaxis_decimals" in dbc_parameters_obj
            ) {
              // usual.decimalsInFloat = dbc_parameters_obj["yaxis_decimals"];
              usual.decimalsInFloat = Number(dbc_parameters_obj["yaxis_decimals"]);
            } else {
              usual.decimalsInFloat = 0;
            }

            if (
              dbc_parameters_obj != undefined &&
              "max_value" in dbc_parameters_obj
            ) {
              usual.max =Number(dbc_parameters_obj["max_value"]);
            }
            if (
              dbc_parameters_obj != undefined &&
              "min_value" in dbc_parameters_obj
            ) {
              usual.min =Number(dbc_parameters_obj["min_value"]);
            }

            if (
              dbc_parameters_obj != undefined &&
              "yaxis_force_nice_scale" in dbc_parameters_obj
            ) {

              usual.forceNiceScale =JSON.parse(dbc_parameters_obj["yaxis_force_nice_scale"]);
              
              if (dbc_parameters_obj['yaxis_force_nice_scale'] !==undefined) {
                  if (JSON.parse(dbc_parameters_obj['yaxis_force_nice_scale']) == false){
                if ("yaxis_tick_amount" in dbc_parameters_obj) {
                        usual.tickAmount =Number(dbc_parameters_obj["yaxis_tick_amount"]);
                        }else{
                          console.log("")
                        }
                  }
                
              }
            } else {
                                                        usual.forceNiceScale= true;
                  }

            if (
              dbc_parameters_obj != undefined &&
              "yaxis_scale_series_name" in dbc_parameters_obj
            ) {
              usual.seriesName = dbc_parameters_obj["yaxis_scale_series_name"];
            }
            if (
              dbc_parameters_obj != undefined &&
              "yaxis_scale_display" in dbc_parameters_obj
            ) {
              usual.show =JSON.parse(dbc_parameters_obj["yaxis_scale_display"]);
            }
            if (
              dbc_parameters_obj != undefined &&
              "display_opposite" in dbc_parameters_obj
            ) {
              usual.opposite = JSON.parse(dbc_parameters_obj["display_opposite"]);
            }

            usual.showAlways = true;




             usual.labels = {
                  // formatter: function (val) {
                  //   return parseInt(val) === val ? val : ''
                  // }
                  // formatter: function (val) {
                  //   return val.toFixed(decimals);
                  // }
                  // formatter: (value) => Math.floor(value),
                }

            if (usual.show == true) {
              yaxisArray.push(usual);
            }

            {
              multi_yaxis_display_array.push(usual);
              console.log(count);
            }
          });

          console.log("single chart", yaxisArray);
          console.log("multiple line chart",multi_yaxis_display_array)
          if (yaxisArray.length == 1) {
            return yaxisArray;
                } else {
            return multi_yaxis_display_array;
                }
              },

          getAnnotationData(value) {
                let originalValue = value;
          console.log("checking annotation values", value);
                if (value == "null") {
                  value = -Infinity;
                } else {
                  value = originalValue;
                }
                return value;
              }
    }

  }
  </script>